import React from 'react';
import Rodal from 'rodal';
import { IApplication } from '../types';

type Props = {
  show: boolean,
  submitting: boolean,
  applications: IApplication[],
  onClose: () => void,
  onConfirm: () => void,
};

// Existe separado do CreateEnrollmentModal porque aquele recebe uma única inscrição e
// escreve o texto no singular; ele continua servindo a tela individual, sem alteração.
const PromoteApplicationsModal = ({
  show,
  submitting,
  applications,
  onClose,
  onConfirm,
}: Props) => (
  <Rodal
    closeOnEsc
    width={620}
    height={420}
    visible={show}
    onClose={onClose}
    className="convocation-modal"
    customStyles={{ padding: 0, borderRadius: 18, overflow: 'hidden' }}
  >
    <div className="cvm-container">
      <div className="cvm-header">
        <span className="cvm-kicker">Matrícula</span>
        <h2>Gerar matrícula</h2>
      </div>
      <div className="cvm-body">
        <p className="cvm-summary">
          Será gerada a matrícula de <b>{applications.length} candidato(s)</b>.
          Essa ação não poderá ser desfeita.
        </p>
        <div className="cvm-candidates">
          {applications.map(application => (
            <div key={application.id} className="cvm-candidate">
              <div className="cvm-candidate-info">
                <strong>{application.assumed_name || application.real_name}</strong>
                <span>{application.desired_onboarding.field_step}º Período</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="cvm-footer">
        <button className="btn btn-black" type="button" onClick={onClose}>Cancelar</button>
        <div className="cvm-footer-right">
          <button
            className="btn btn-primary"
            type="button"
            disabled={submitting || applications.length === 0}
            onClick={onConfirm}
          >
            {submitting ? 'Gerando...' : 'Gerar matrícula'}
          </button>
        </div>
      </div>
    </div>
  </Rodal>
);

export default PromoteApplicationsModal;
